import styled from '@emotion/styled'
import { Text } from 'mailup-web-components'

export const StyledText = styled(Text)`
  font-size: 28px !important;
  margin-right: 4px;
`

export const IconWrapperLarge = styled.span`
  svg {
    font-size: 43px;
    color: var(--silver);
  }
`
export const IconWrapperSmall = styled.span`
  svg {
    font-size: ${({ fonstSize }) => fonstSize || '16px'};
    color: ${({ color }) => color || 'var(--silver)'};
  }
`